import { render, staticRenderFns } from "./GoodsRegisterRequest.vue?vue&type=template&id=162371af"
import script from "./GoodsRegisterRequest.vue?vue&type=script&lang=js"
export * from "./GoodsRegisterRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports